import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { ErrorMessageWrapperDataHooks } from './types';

export interface ErrorMessageWrapperDriver extends BaseUniDriver {
  isErrorVisible(): Promise<boolean>;
  getErrorMessage(): Promise<string>;
  getErrorMessageId(): Promise<string>;
  getLang(): Promise<string>;
}

export const errorMessageWrapperDriverFactory = (
  base: UniDriver,
): ErrorMessageWrapperDriver => {
  const getErrorMessageElement = () =>
    base.$(`[data-hook="${ErrorMessageWrapperDataHooks.Message}"]`);

  return {
    ...baseUniDriverFactory(base),
    isErrorVisible: () => getErrorMessageElement().exists(),
    getErrorMessage: () => getErrorMessageElement().text(),
    getErrorMessageId: () => getErrorMessageElement().attr('id'),
    getLang: () => base.attr('lang'),
  };
};
